// extracted by mini-css-extract-plugin
export default {"BackHeader":"BackHeader_BackHeader__6lCBt","icon":"BackHeader_icon__mmKEb","title":"BackHeader_title__-GrYC"};